// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard React context
import { useSoftUIController } from "context";
import {useLocation} from "react-router-dom";
import {useEffect} from "react";
import {setLayout} from "../../../store/actions/app-actions";

function DashboardLayout({ children }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction } = controller;
  const { pathname } = useLocation();

    useEffect(() => {
        setLayout(dispatch, "dashboard");
    }, [pathname]);

  return (
    <SoftBox
        sx={({ breakpoints, transitions, functions: { pxToRem } }) => {
            const marginDirection = direction === "rtl" ? "marginRight" : "marginLeft";
            return {
        p: 3,
        position: "relative",

        [breakpoints.up("xl")]: {
            [marginDirection]: miniSidenav ? pxToRem(120) : pxToRem(274),
          transition: transitions.create(["margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard,
          }),
        },
            }
        }}
    >
      {children}
    </SoftBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;
